import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Alert, Row, Col, Table, Button, Input, Label, FormGroup, Modal, ModalHeader, ModalBody } from "reactstrap";
import { BASE_URL } from "../../../../constants";
import DepositReportTable from "./table";
import { FaCalendar, FaTimes } from "react-icons/fa";

function DepositReportAdd() {
	const navigate = useNavigate();
	const [errMsg, setErrMsg] = useState(null);
	const [properties, setProperties] = useState([]);
	const [selectedProperty, setSelectedProperty] = useState(null);
	const [basedOnType, setBasedOnType] = useState('INSPECTION');
	const [basedOnId, setBasedOnId] = useState(null); 
	const [basedOnOptions, setBasedOnOptions] = useState([]); 
	const [selectedInspections, setSelectedInspections] = useState([null, null]);
	const [securityDeposit, setSecurityDeposit] = useState('');
	const [petDeposit, setPetDeposit] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [propertyAreas, setPropertyAreas] = useState([]);
	const [reportItems, setReportItems] = useState([]);
	const [viewItemImage, setViewItemImage] = useState(null);

	useEffect(() => {
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/property/all`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						setProperties(data.result.map((property) => ({
							name: property.name,
							id: property.id
						})));
					}
					else {
						console.error("Error: Unable to fetch property data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {
			console.error("Error: Authorization token is missing.");
		}
	}, []);

	useEffect(() => {

		setPropertyAreas([]);

		if (selectedProperty) {
			const token = localStorage.getItem('token');
			if (token) {
				setIsLoading(true);
				fetch(`${BASE_URL}/reports/deposit/property-areas/${selectedProperty}`, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
					.then(response => response.json())
					.then(data => {
						setIsLoading(false);
						if (data.status) {
							setPropertyAreas([...data.result]);
						}
						else {
							console.error("Error: Unable to fetch property data.");
						}
					})
					.catch(error => console.error("Error fetching data:", error));
			}
		}

	}, [selectedProperty])

	useEffect(() => {
		if (!selectedProperty) {
			return;
		}
		setBasedOnId(null);
		setSelectedInspections([null, null]);
		setBasedOnOptions([]);
		const token = localStorage.getItem('token');

		if (basedOnType == 'INSPECTION') {
			fetch(`${BASE_URL}/dropdown/inspections?property_id=${selectedProperty}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						setBasedOnOptions(data.result.map((inspection) => ({
							label: `${formatInspectionActivity(inspection.activity)} - ${new Date(inspection.inspection_date).toLocaleDateString('en-US')}`,
							id: inspection.id,
							data: {...inspection}
						})));
					}
					else {
						console.error("Error: Unable to fetch inspection data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		} else {

			fetch(`${BASE_URL}/dropdown/comparison-reports?property_id=${selectedProperty}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						setBasedOnOptions(data.result.map((report) => ({
							label: `${formatInspectionActivity(report.inspection_1_activity)} - ${formatInspectionActivity(report.inspection_2_activity)} - ${new Date(report.created_at).toLocaleDateString('en-US')}`,
							id: report.id,
							data: {...report}
						})));
					}
					else {
						console.error("Error: Unable to fetch inspection data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		}
	}, [basedOnType, selectedProperty])

	useEffect(() => {
		if (!basedOnId || !selectedProperty || basedOnOptions.length == 0) {
			return;
		}

		if (basedOnType == 'INSPECTION') {
			getInspectionDetails(basedOnId, 0);
		} else {
			const report = basedOnOptions.find(option => option.id == basedOnId);
			if (report) {
				const inspection1 = report.data.inspection_1;
				const inspection2 = report.data.inspection_2;
				console.log('report', inspection1, inspection2);
				getInspectionDetails(inspection1, 0);
				getInspectionDetails(inspection2, 1);
			}
		}
	}, [basedOnId, basedOnOptions])

	const getInspectionDetails = (ispId, index) => {
		if (ispId == null || ispId == "") {
			// setErrMsg("Please select inspection");
			return;
		}

		setSelectedInspections(prev => {
			const prevReports = [...prev];
			prevReports[index] = null;
			return prevReports;
		})
		const token = localStorage.getItem('token');
		if (token) {
			fetch(`${BASE_URL}/inspection/${ispId}`, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(response => response.json())
				.then(data => {
					if (data.status) {
						const formattedInspection = { ...data.result };
						formattedInspection.created_at = new Date(data.result.created_at).toLocaleDateString('en-US');
						
						setSelectedInspections(prev => {
							const prevReports = [...prev];
							prevReports[index] = formattedInspection;
							return prevReports;
						})
					} else {
						console.error("Error: Unable to fetch inspections data.");
					}
				})
				.catch(error => console.error("Error fetching data:", error));
		}
	}

	const formatInspectionActivity = (activity) => {
		return activity
			.replace(/_/g, '-')
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
			.join(' ');
	};

	const handleSubmit = () => {
		if (!selectedProperty) {
			setErrMsg("Please select a property.");
			return;
		}
		if (securityDeposit < 0) {
			setErrMsg("Security deposit cannot be negative.");
			return;
		}
		if (petDeposit < 0) {
			setErrMsg("Pet deposit cannot be negative.");
			return;
		}
		setErrMsg(null);
		const token = localStorage.getItem('token');
		if (!token) {
			setErrMsg("Authorization token is missing.");
			return;
		}
		const data = {
			propertyId: selectedProperty,
			securityDeposit: securityDeposit,
			petDeposit: petDeposit,
			reportItems: reportItems,
			basedOnType: basedOnType,
			basedOnId: basedOnId,
		};

		fetch(`${BASE_URL}/reports/deposit/add`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(data)
		})
			.then(response => response.json())
			.then(data => {
				if (data.status) {
					alert(data.message)
					navigate(`/deposit-withholding-report/view/${data.result}`);
				} else {
					setErrMsg(data.message || "Failed to create deposit report.");
				}
			})
			.catch(error => {
				console.error("Error creating deposit report:", error);
				setErrMsg("An error occurred while creating the deposit report.");
			});
	}

	// console.log('reportItems', reportItems);

	return (
		<div className="content">
			{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}

			<h3>Create Deposit Withholding Report</h3>
			
			<Card>
				<CardBody>
					
					<Row className="mb-2">
						<Col md={6}>
							<FormGroup>
								<Label>Property</Label>
								<Input type="select" name="type" id="type" value={selectedProperty} onChange={(e) => setSelectedProperty(e.target.value)}>
									<option value="">Select Property</option>
									{properties.map(p => {
										return (
											<option key={p.id} value={p.id}>{p.name}</option>
										)
									})}
								</Input>
							</FormGroup>
						</Col>
						<Col md={3}>
							<FormGroup>
								<Label>Security Deposit</Label>
								<Input type="number" value={securityDeposit} onChange={(e) => setSecurityDeposit(e.target.value)} />
							</FormGroup>
						</Col>
						<Col md={3}>
							<FormGroup>
								<Label>Pet Deposit</Label>
								<Input type="number" value={petDeposit} onChange={(e) => setPetDeposit(e.target.value)} />
							</FormGroup>
						</Col>
					</Row>
					<Row className="mb-4">
						<Col md={3}>
							<FormGroup>
								<Label>Report Type</Label>
								<Input type="select" name="report_type" id="report_type" value={basedOnType} onChange={(e) => setBasedOnType(e.target.value)}>
									<option value="INSPECTION">Inspection</option>
									<option value="COMPARISON">Comparison Report</option>
								</Input>
							</FormGroup>
							
						</Col>
						<Col md={3}>
							<FormGroup>
								<Label>{(basedOnType == 'INSPECTION') ? 'Pick an Inspection' : 'Pick an Comparison Report'}</Label>
								<Input type="select" name="type" id="type" value={basedOnId} onChange={(e) => setBasedOnId(e.target.value)}>
									<option value="">{(basedOnType == 'INSPECTION') ? 'Select Inspection' : 'Select Comparison Report'}</option>
									{basedOnOptions.map(p => {
										return (
											<option key={p.id} value={p.id}>{p.label}</option>
										)
									})}
								</Input>
							</FormGroup>
						</Col>
					</Row>

					{(selectedProperty && basedOnId) ? (
						<>
						{isLoading ? (
							<p className="text-center">Loading...</p>
						) : (
							<DepositReportTable 
								propertyAreas={propertyAreas}
								reportItems={reportItems}
								setReportItems={setReportItems}
								isEdit={true}
								selectedInspections={selectedInspections}
								basedOnType={basedOnType}
								setViewItemImage={setViewItemImage}
							/>
						)}
						</>
					) : null}

					{errMsg !== null && <Alert color="danger">{errMsg}</Alert>}
					<div className='text-end'>
						<Button color="primary" type="button" size="lg" onClick={handleSubmit}>Create Report</Button>
					</div>
				</CardBody>
			</Card>

			{(viewItemImage !== null) ? (
			<Modal isOpen={viewItemImage !== null} toggle={() => setViewItemImage(null)} centered size="lg">
				<ModalHeader toggle={() => setViewItemImage(null)} style={{ display: 'flex', justifyContent: 'space-between' }} close={
					<button className="close" onClick={() => setViewItemImage(null)} style={{ outline: 'none', border: 'none', background: 'transparent' }}>
						<FaTimes size={20} />
					</button>
				}>
					<div>{viewItemImage?.itemName}</div>
				</ModalHeader>
				<ModalBody>
					<img
						src={viewItemImage?.image}
						alt={viewItemImage?.itemName}
						style={{ width: '100%' }}
					/>

					<div style={{ marginTop: '15px' }}></div>

					<p><FaCalendar /> {new Date(viewItemImage?.createdAt).toLocaleDateString('en-US')}</p>
				</ModalBody>
			</Modal>
			) : null}
		</div>
	);
}

export default DepositReportAdd;
